<template>
  <div class="action-buttons flex flex-col gap-6 print:hidden">
    <div class="action-buttons__icon-buttons flex items-center justify-between">
      <SharedFavoriteCarButton v-if="carDetail?.documentId" :car-id="carDetail?.documentId" :car-detail="carDetail" size="medium" />

      <SharedIconButton variant="accent" :title="t('components.carDetail.actionButtons.print')" @click="print">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path
            d="M17 5H16V0H4V5H3C1.346 5 0 6.346 0 8V15C0 16.103 0.897 17 2 17H4V20H16V17H18C19.103 17 20 16.103 20 15V8C20 6.346 18.654 5 17 5ZM6 2H14V5H6V2ZM14 18H6V14H14V18ZM18 15H16V12H4V15H2V8C2 7.449 2.449 7 3 7H17C17.552 7 18 7.449 18 8V15Z"
            fill="currentColor"
          />
          <path d="M12 8H16V10H12V8Z" fill="currentColor" />
        </svg>
      </SharedIconButton>

      <SharedIconButton variant="accent" :title="t('components.carDetail.actionButtons.shareInFacebook')" @click="shareInFacebook">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            d="M22.4004 12.3038C22.4004 6.74719 17.9233 2.24268 12.4004 2.24268C6.87754 2.24268 2.40039 6.74719 2.40039 12.3038C2.40039 17.3255 6.05723 21.4879 10.8379 22.2427V15.2121H8.29883V12.3038H10.8379V10.0872C10.8379 7.56564 12.3309 6.1728 14.615 6.1728C15.7092 6.1728 16.8535 6.36931 16.8535 6.36931V8.84529H15.5926C14.3504 8.84529 13.9629 9.6209 13.9629 10.4166V12.3038H16.7363L16.293 15.2121H13.9629V22.2427C18.7436 21.4879 22.4004 17.3257 22.4004 12.3038Z"
            fill="currentColor"
          />
        </svg>
      </SharedIconButton>

      <SharedIconButton variant="accent" :title="t('components.carDetail.actionButtons.sendInEmail')" @click="sendInEmail">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            d="M20.4 4H4.40002C3.29702 4 2.40002 4.897 2.40002 6V18C2.40002 19.103 3.29702 20 4.40002 20H20.4C21.503 20 22.4 19.103 22.4 18V6C22.4 4.897 21.503 4 20.4 4ZM20.4 6V6.511L12.4 12.734L4.40002 6.512V6H20.4ZM4.40002 18V9.044L11.786 14.789C11.9611 14.9265 12.1774 15.0013 12.4 15.0013C12.6227 15.0013 12.8389 14.9265 13.014 14.789L20.4 9.044L20.402 18H4.40002Z"
            fill="currentColor"
          />
        </svg>
      </SharedIconButton>

      <SharedIconButton variant="accent" :title="t('components.carDetail.actionButtons.shareInWhatsapp')" @click="shareToWhatsapp">
        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M21.303 3.48774C19.0469 1.23981 16.0466 0.00130343 12.8499 0C6.26335 0 0.902591 5.33471 0.90002 11.8918C0.899099 13.9879 1.44936 16.0338 2.49513 17.8373L0.799805 24L7.13459 22.3462C8.87997 23.2937 10.8451 23.7931 12.8451 23.7938H12.85C12.8496 23.7938 12.8504 23.7938 12.85 23.7938C19.4358 23.7938 24.797 18.4585 24.7998 11.9013C24.801 8.72353 23.5591 5.73558 21.303 3.48774ZM12.8499 21.7853H12.8459C11.0638 21.7846 9.31571 21.308 7.79074 20.4075L7.4281 20.1933L3.66895 21.1746L4.67237 17.527L4.43619 17.153C3.44199 15.5792 2.9169 13.7602 2.91767 11.8925C2.91981 6.44248 7.37547 2.00859 12.854 2.00859C15.5068 2.00941 18.0006 3.03898 19.8759 4.90737C21.751 6.77577 22.7832 9.25929 22.7821 11.9005C22.7799 17.3509 18.3243 21.7853 12.8499 21.7853Z"
            fill="currentColor"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M18.2983 14.3821C17.9998 14.2334 16.5317 13.5146 16.2581 13.4153C15.9844 13.3162 15.7853 13.2666 15.5863 13.5641C15.3873 13.8615 14.815 14.5309 14.6408 14.7292C14.4667 14.9275 14.2925 14.9524 13.9939 14.8035C13.6954 14.6548 12.7333 14.3411 11.5928 13.3287C10.7052 12.5407 10.106 11.5676 9.93172 11.2701C9.75758 10.9727 9.91319 10.8118 10.0627 10.6636C10.197 10.5305 10.3613 10.3166 10.5106 10.143C10.6599 9.96959 10.7096 9.84552 10.8092 9.64735C10.9087 9.44899 10.859 9.27544 10.7843 9.12675C10.7096 8.97802 10.1125 7.51537 9.86371 6.92028C9.62127 6.34093 9.37515 6.41943 9.19184 6.41021C9.01794 6.40157 8.81862 6.39978 8.6196 6.39978C8.42058 6.39978 8.09703 6.47417 7.82341 6.7716C7.54973 7.06912 6.77832 7.78808 6.77832 9.25058C6.77832 10.7133 7.84824 12.1263 7.99755 12.3246C8.1468 12.523 10.103 15.5243 13.0982 16.8115C13.8106 17.1177 14.3668 17.3005 14.8004 17.4374C15.5157 17.6637 16.1666 17.6317 16.681 17.5552C17.2547 17.4699 18.4476 16.8364 18.6964 16.1423C18.9453 15.4481 18.9453 14.8531 18.8706 14.7292C18.796 14.6053 18.5969 14.5309 18.2983 14.3821Z"
            fill="currentColor"
          />
        </svg>
      </SharedIconButton>

      <SharedIconButton variant="accent" :title="t('components.carDetail.actionButtons.copyLink')" @click="copyLink"
        ><svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
          <path
            d="M20.6 2H10.6C9.49698 2 8.59998 2.897 8.59998 4V8H4.59998C3.49698 8 2.59998 8.897 2.59998 10V20C2.59998 21.103 3.49698 22 4.59998 22H14.6C15.703 22 16.6 21.103 16.6 20V16H20.6C21.703 16 22.6 15.103 22.6 14V4C22.6 2.897 21.703 2 20.6 2ZM4.59998 20V10H14.6L14.602 20H4.59998ZM20.6 14H16.6V10C16.6 8.897 15.703 8 14.6 8H10.6V4H20.6V14Z"
            fill="currentColor"
          />
        </svg>
      </SharedIconButton>
    </div>

    <div class="flex flex-col gap-4 lg:grid lg:grid-cols-2">
      <SharedButton
        v-if="['Verkauft', 'Vorverkauft', 'Gesperrt', 'Überprüfen', 'Lagernd'].includes(carDetail?.vehicle_status || '')"
        variant="primary"
        :label="t('components.carDetail.actionButtons.bookViewing')"
        @click="bookViewing"
        class="w-full lg:col-span-2"
      >
        <template #icon>
          <svg class="text-white mr-2" xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
            <path
              d="M19.272 6.156L17.904 2.051C17.7056 1.45348 17.3238 0.9337 16.8131 0.565508C16.3024 0.197316 15.6886 -0.000558206 15.059 1.18278e-06H5.941C5.31139 -0.000558206 4.69761 0.197316 4.18688 0.565508C3.67615 0.9337 3.29445 1.45348 3.096 2.051L1.728 6.156C1.36461 6.30848 1.05428 6.56476 0.835845 6.89277C0.617412 7.22077 0.500589 7.60592 0.5 8V13C0.5 13.753 0.923 14.402 1.539 14.743C1.526 14.809 1.5 14.869 1.5 14.938V17C1.5 17.2652 1.60536 17.5196 1.79289 17.7071C1.98043 17.8946 2.23478 18 2.5 18H3.5C3.76522 18 4.01957 17.8946 4.20711 17.7071C4.39464 17.5196 4.5 17.2652 4.5 17V15H16.5V17C16.5 17.2652 16.6054 17.5196 16.7929 17.7071C16.9804 17.8946 17.2348 18 17.5 18H18.5C18.7652 18 19.0196 17.8946 19.2071 17.7071C19.3946 17.5196 19.5 17.2652 19.5 17V14.938C19.5 14.869 19.474 14.808 19.461 14.743C19.7744 14.5721 20.0362 14.3202 20.2189 14.0136C20.4017 13.707 20.4988 13.357 20.5 13V8C20.5 7.171 19.992 6.459 19.272 6.156ZM2.5 13V8H18.5L18.502 13H2.5ZM5.941 2H15.058C15.489 2 15.871 2.274 16.007 2.684L17.113 6H3.887L4.992 2.684C5.05835 2.4848 5.18572 2.31153 5.35605 2.18876C5.52638 2.06599 5.73104 1.99995 5.941 2Z"
              fill="currentColor"
            />
            <path d="M5 12C5.82843 12 6.5 11.3284 6.5 10.5C6.5 9.67157 5.82843 9 5 9C4.17157 9 3.5 9.67157 3.5 10.5C3.5 11.3284 4.17157 12 5 12Z" fill="currentColor" />
            <path d="M16 12C16.8284 12 17.5 11.3284 17.5 10.5C17.5 9.67157 16.8284 9 16 9C15.1716 9 14.5 9.67157 14.5 10.5C14.5 11.3284 15.1716 12 16 12Z" fill="currentColor" />
          </svg>
        </template>
      </SharedButton>

      <SharedButton variant="secondary" to="tel:+43311280100" :label="t('components.carDetail.actionButtons.contact')" class="w-full !flex md:!hidden">
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="19" viewBox="0 0 20 19" fill="none">
            <path
              d="M15.2071 10.293C15.1143 10.2 15.0041 10.1263 14.8828 10.076C14.7615 10.0257 14.6314 9.99976 14.5001 9.99976C14.3688 9.99976 14.2387 10.0257 14.1174 10.076C13.9961 10.1263 13.8859 10.2 13.7931 10.293L12.1991 11.887C11.4601 11.667 10.0811 11.167 9.20709 10.293C8.33309 9.41896 7.83309 8.03996 7.61309 7.30096L9.20709 5.70696C9.30004 5.61417 9.37377 5.50397 9.42408 5.38265C9.47439 5.26134 9.50029 5.13129 9.50029 4.99996C9.50029 4.86862 9.47439 4.73858 9.42408 4.61726C9.37377 4.49595 9.30004 4.38575 9.20709 4.29296L5.20709 0.292957C5.1143 0.200011 5.0041 0.126273 4.88278 0.0759627C4.76147 0.0256519 4.63142 -0.000244141 4.50009 -0.000244141C4.36876 -0.000244141 4.23871 0.0256519 4.1174 0.0759627C3.99608 0.126273 3.88588 0.200011 3.79309 0.292957L1.08109 3.00496C0.70109 3.38496 0.48709 3.90696 0.49509 4.43996C0.51809 5.86396 0.89509 10.81 4.79309 14.708C8.69109 18.606 13.6371 18.982 15.0621 19.006H15.0901C15.6181 19.006 16.1171 18.798 16.4951 18.42L19.2071 15.708C19.3 15.6152 19.3738 15.505 19.4241 15.3837C19.4744 15.2623 19.5003 15.1323 19.5003 15.001C19.5003 14.8696 19.4744 14.7396 19.4241 14.6183C19.3738 14.4969 19.3 14.3867 19.2071 14.294L15.2071 10.293ZM15.0801 17.005C13.8321 16.984 9.56209 16.649 6.20709 13.293C2.84109 9.92696 2.51509 5.64196 2.49509 4.41896L4.50009 2.41396L7.08609 4.99996L5.79309 6.29296C5.67555 6.41041 5.58913 6.55529 5.54164 6.71453C5.49415 6.87376 5.48709 7.04231 5.52109 7.20496C5.54509 7.31996 6.13209 10.047 7.79209 11.707C9.45209 13.367 12.1791 13.954 12.2941 13.978C12.4566 14.0129 12.6254 14.0064 12.7847 13.9591C12.9441 13.9117 13.089 13.825 13.2061 13.707L14.5001 12.414L17.0861 15L15.0801 17.005Z"
              fill="#37B5AA"
            />
          </svg>
        </template>
      </SharedButton>

      <SharedButton variant="secondary" @click="gotoContactForm" :label="t('components.carDetail.actionButtons.inquiry')" class="w-full !hidden md:!flex md:col-span-1">
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path
              d="M14.69 0.879C14.4794 0.668132 14.2293 0.50083 13.954 0.386643C13.6788 0.272456 13.3837 0.213685 13.0857 0.213685C12.7877 0.213685 12.4927 0.272456 12.2174 0.386643C11.9421 0.50083 11.692 0.668132 11.4814 0.879L1.51141 10.849C1.36889 10.992 1.27066 11.1729 1.22841 11.37L0.0204114 17.16C-0.0114814 17.3104 -0.00608675 17.4663 0.0360868 17.6141C0.0782602 17.7619 0.155869 17.8969 0.262247 18.0073C0.368625 18.1177 0.500574 18.2 0.646436 18.2469C0.792299 18.2937 0.947625 18.3037 1.09841 18.276L6.91241 17.151C7.11171 17.1147 7.29563 17.0193 7.43941 16.877L17.4194 6.897C17.847 6.46909 18.0871 5.88886 18.0871 5.284C18.0871 4.67914 17.847 4.0989 17.4194 3.671L14.69 0.879ZM6.32641 15.299L2.13641 16.111L3.00041 11.967L10.4564 4.511L13.7494 7.804L6.32641 15.299ZM16.0014 5.483L15.1574 6.327L11.8714 3.041L12.7144 2.197C12.7615 2.14821 12.8178 2.1095 12.8801 2.08322C12.9425 2.05695 13.0095 2.04364 13.0772 2.04412C13.1448 2.04459 13.2117 2.05885 13.2737 2.086C13.3357 2.11314 13.3915 2.15265 13.4378 2.20206L16.0014 4.76563C16.1003 4.86254 16.157 4.99459 16.1597 5.13352C16.1623 5.27245 16.1107 5.40658 16.0156 5.508L16.0014 5.483Z"
              fill="#37B5AA"
            />
            <path d="M19 18H1V20H19V18Z" fill="#37B5AA" />
          </svg>
        </template>
      </SharedButton>

      <SharedButton variant="secondary" :label="t('components.carDetail.actionButtons.callOnWhatsapp')" @click="callOnWhatsapp" class="w-full lg:col-span-1">
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path
              d="M5.5 18V21.766L11.777 18H16.5C17.603 18 18.5 17.103 18.5 16V8C18.5 6.897 17.603 6 16.5 6H4.5C3.397 6 2.5 6.897 2.5 8V16C2.5 17.103 3.397 18 4.5 18H5.5ZM4.5 8H16.5V16H11.223L7.5 18.234V16H4.5V8Z"
              fill="#37B5AA"
            />
            <path d="M20.5 2H8.5C7.397 2 6.5 2.897 6.5 4H18.5C19.603 4 20.5 4.897 20.5 6V14C21.603 14 22.5 13.103 22.5 12V4C22.5 2.897 21.603 2 20.5 2Z" fill="#37B5AA" />
          </svg>
        </template>
      </SharedButton>

      <SharedButton
        variant="secondary"
        :label="t('components.carDetail.actionButtons.openTradeInForm')"
        @click="onTradeInClick"
        :class="tradeInShareRow ? 'w-full lg:col-span-1 !px-2 md:!px-2' : 'w-full lg:col-span-2'"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" class="text-[#37B5AA]">
            <path d="M18.9 8.60001H15.1V8.70001H18.9V8.60001Z" fill="currentColor" stroke="currentColor" stroke-width="0.1" />
            <path
              d="M22 6.70001H20.3L18.9 2.60001C18.7 2.00001 18.1 1.60001 17.5 1.60001H6.49998C5.79998 1.60001 5.19998 2.00001 4.99998 2.60001L3.59998 6.70001H1.79998C1.69998 6.70001 1.59998 6.80001 1.59998 7.00001V7.40001C1.59998 7.60001 1.69998 7.70001 1.89998 7.70001H2.99998V7.80001V8.60001V8.70001V16.6C2.99998 17.1 3.49998 17.6 3.99998 17.6H4.99998C5.49998 17.6 5.99998 17.1 5.99998 16.6V15.6H11V13.6H4.89998V8.70001V8.60001H15.1H18.9V8.70001V12.9L20.9 14.9V8.70001V8.60001V7.70001H22C22.2 7.70001 22.3 7.60001 22.3 7.40001V7.00001C22.3 6.80001 22.1 6.70001 22 6.70001ZM5.69998 6.70001L6.79998 3.60001H17.1L18.2 6.70001H5.69998Z"
              fill="currentColor"
              stroke="currentColor"
              stroke-width="0.1"
            />
            <path d="M15.1 8.60001H4.90002V8.70001H15.1V8.60001Z" fill="currentColor" stroke="currentColor" stroke-width="0.1" />
            <path
              d="M21.815 17.965L17.635 13.785C17.445 13.595 17.2075 13.5 16.97 13.5H13.55C13.0275 13.5 12.6 13.9275 12.6 14.45V17.87C12.6 18.1075 12.695 18.345 12.885 18.535L17.065 22.715C17.445 23.095 18.0625 23.095 18.395 22.715L21.815 19.295C22.195 18.9625 22.195 18.345 21.815 17.965ZM14.7375 16.35C14.3575 16.35 14.025 16.0175 14.025 15.6375C14.025 15.2575 14.3575 14.925 14.7375 14.925C15.1175 14.925 15.45 15.2575 15.45 15.6375C15.45 16.0175 15.1175 16.35 14.7375 16.35Z"
              fill="currentColor"
              stroke="currentColor"
              stroke-width="0.1"
            />
            <path
              d="M17.1 11.5H6.3C6.1 11.5 6 11.4 6 11.2V10.3C6 10.1 6.1 10 6.3 10H17.1C17.3 10 17.4 10.1 17.4 10.3V11.2C17.4 11.3 17.3 11.5 17.1 11.5Z"
              fill="currentColor"
              stroke="currentColor"
              stroke-width="0.1"
            />
          </svg>
        </template>
      </SharedButton>

      <!-- Santander financing calculator, behind the financingCalculator feature switch -->
      <SharedButton
        v-if="financingCalculatorEnabled"
        variant="secondary"
        :label="t('components.carDetail.actionButtons.openFinancingModal')"
        @click="openFinancingModal"
        class="w-full lg:col-span-1 !px-2 md:!px-2"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
            <path
              d="M12.5 15C10.66 15 10.5 14.14 10.5 14H8.5C8.5 14.92 9.16 16.55 11.5 16.92V18H13.5V16.92C15.5 16.58 16.5 15.29 16.5 14C16.5 12.88 15.98 11 12.5 11C10.5 11 10.5 10.37 10.5 10C10.5 9.63 11.2 9 12.5 9C13.8 9 13.89 9.64 13.9 10H15.9C15.8865 9.31876 15.6415 8.66241 15.2053 8.13896C14.769 7.61551 14.1676 7.25614 13.5 7.12V6H11.5V7.09C9.5 7.42 8.5 8.71 8.5 10C8.5 11.12 9.02 13 12.5 13C14.5 13 14.5 13.68 14.5 14C14.5 14.32 13.88 15 12.5 15Z"
              fill="#37B5AA"
            />
            <path
              d="M2.5 2V4H4.5V21C4.5 21.2652 4.60536 21.5196 4.79289 21.7071C4.98043 21.8946 5.23478 22 5.5 22H19.5C19.7652 22 20.0196 21.8946 20.2071 21.7071C20.3946 21.5196 20.5 21.2652 20.5 21V4H22.5V2H2.5ZM18.5 20H6.5V4H18.5V20Z"
              fill="#37B5AA"
            />
          </svg>
        </template>
      </SharedButton>

      <SharedButton
        v-if="showPriceWatchButton"
        variant="secondary"
        :label="priceWatcherButtonLabel"
        @click="onPriceWatcherClick"
        :class="financingCalculatorEnabled ? 'w-full !px-2 md:!px-4 lg:col-span-2' : 'w-full !px-2 md:!px-4 lg:col-span-1'"
        labelClass="md:w-max"
      >
        <template #icon>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M17.3369 1.81L21.9439 5.655L20.6639 7.19L16.0539 3.347L17.3369 1.81ZM6.66288 1.81L7.94489 3.346L3.33688 7.19L2.05688 5.654L6.66288 1.81ZM11.9999 4C7.02988 4 2.99988 8.03 2.99988 13C2.99988 17.97 7.02988 22 11.9999 22C16.9699 22 20.9999 17.97 20.9999 13C20.9999 8.03 16.9699 4 11.9999 4ZM11.9999 20C8.13988 20 4.99988 16.86 4.99988 13C4.99988 9.14 8.13988 6 11.9999 6C15.8599 6 18.9999 9.14 18.9999 13C18.9999 16.86 15.8599 20 11.9999 20ZM12.9999 9H10.9999V12H7.99988V14H10.9999V17H12.9999V14H15.9999V12H12.9999V9Z"
              fill="#37B5AA"
              stroke="#37B5AA"
              stroke-width="0.1"
            />
          </svg>
        </template>
      </SharedButton>
    </div>
    <ClientOnly>
      <component v-for="(component, i) in specialActionComponents" :is="component" :key="i" />
    </ClientOnly>
  </div>
</template>

<script setup lang="ts">
  import type { GraphQLCarDetail } from '~/types/graphql';
  import type { Toast } from '~/components/GlobalToast/index.vue';
  import type { AuwsObject } from '~/types/types';

  interface EventData {
    event:
      | 'print'
      | 'share_in_facebook'
      | 'send_in_email'
      | 'copy_link'
      | 'book_viewing'
      | 'share_to_whatsapp'
      | 'call_on_whatsapp'
      | 'open_financing_modal'
      | 'goto_contact_form'
      | 'open_trade_in_form'
      | 'open_price_watcher_modal';
    page_location: string;
    page_title: string;
    vehicle_id: string;
    make?: string;
    model?: string;
    price?: number;
    fuel_type?: string;
    manufactured_at?: string;
  }

  const { push } = useDataLayer();

  // const { width } = useWindowSize();

  const sendEvent = (event_type: EventData['event']) => {
    const eventData: EventData = {
      event: event_type,
      page_location: window.location.href,
      page_title: window.document.title,
      vehicle_id: carDetail ? carDetail.internal_vehicle_no?.toString() || '' : '',
    };
    if (carDetail) {
      eventData.make = carDetail.make?.name;
      eventData.model = carDetail.model;
      eventData.manufactured_at = carDetail.year_of_manufacture?.toString() || '';
      eventData.price = carDetail.asking_price || undefined;
      eventData.fuel_type = carDetail.fuel_type || undefined;
    }
    push(eventData);
  };

  const { t } = useI18n();

  const carDetail = inject<GraphQLCarDetail>('carDetail');

  const print = async () => {
    if (!import.meta.client) return;

    // load in lazy images
    const lazyImages = document.querySelectorAll<HTMLImageElement>('img[loading="lazy"]');
    const loadPromises: Promise<void>[] = [];

    lazyImages.forEach(img => {
      img.setAttribute('loading', 'eager');

      if (!img.complete) {
        const promise = new Promise<void>(resolve => {
          img.onload = () => {
            resolve();
          };
          img.onerror = () => {
            // ignore error
            resolve();
          };
        });

        loadPromises.push(promise);
      }
    });

    await Promise.all(loadPromises);

    sendEvent('print');

    try {
      window.print();
    } catch (err) {
      // Some iOS in-app browsers (e.g. Google app's WKWebView) override
      // window.print with a webkit messageHandler bridge whose native handler
      // isn't registered, throwing on .postMessage. Swallow only that case;
      // re-throw anything else so we don't hide unrelated bugs.
      const isMissingWebkitPrintHandler = err instanceof TypeError && /webkit.*messageHandlers.*print/i.test(err.message);
      if (!isMissingWebkitPrintHandler) throw err;
    }
  };

  const shareInFacebook = () => {
    sendEvent('share_in_facebook');

    const urlToShare = encodeURIComponent(window.location.href);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${urlToShare}`, 'facebookShare', 'width=600,height=600');
  };

  const sendInEmail = () => {
    sendEvent('send_in_email');

    window.open(`mailto:?subject=${encodeURIComponent(carDetail!.make!.name) + ' ' + carDetail!.model}&body=${encodeURIComponent(window.location.href)}`, '_blank');
  };

  const eventBus = useEventBus();

  const copyLink = () => {
    sendEvent('copy_link');

    navigator.clipboard.writeText(window.location.href);

    const toast: Toast = {
      show: true,
      message: t('components.carDetail.actionButtons.linkCopied'),
      type: 'foreground',
    };

    eventBus.emit('add-global-toast', toast);
  };

  const { getUniqueComponents } = useSpecialActionComponents();

  const specialActionComponents = computed(() => {
    const specialActions = ['book_test_drive', 'financing_modal'];

    // Only run on client to avoid hydration mismatch
    if (import.meta.client) {
      const uniqueActions = getUniqueComponents(specialActions);
      const components: any[] = [];

      uniqueActions.forEach(action => {
        switch (action) {
          // case 'book_test_drive':
          //   components.push(defineAsyncComponent(() => import('~/components/Shared/BookTestDrive/index.vue')));
          //   break;
          default:
            break;
        }
      });

      return components;
    }

    return [];
  });

  const bookViewing = () => {
    eventBus.emit('open-book-test-drive-modal', {
      carDetail: carDetail,
    });
  };

  const shareToWhatsapp = () => {
    sendEvent('share_to_whatsapp');

    const encodedText = encodeURIComponent([carDetail?.make?.name, carDetail?.model].filter(Boolean).join(' ') + ' ' + window.location.href);

    const shareUrl = `https://api.whatsapp.com/send?text=${encodedText}`;

    // Open the link in a new tab
    window.open(shareUrl, '_blank');
  };

  const callOnWhatsapp = () => {
    sendEvent('call_on_whatsapp');

    const vehicle = [carDetail?.make?.name, carDetail?.model].filter(Boolean).join(' ');
    const idnr = carDetail?.internal_vehicle_no?.toString() ?? '';
    const url = window.location.href;
    const text = t('components.carDetail.actionButtons.callOnWhatsappMessage', { vehicle, idnr, url });

    window.open(`https://wa.me/436642301213?text=${encodeURIComponent(text)}`, '_blank');
  };

  const financingCalculatorEnabled = useFeature('financingCalculator');

  const openFinancingModal = () => {
    sendEvent('open_financing_modal');

    eventBus.emit('open-financing-modal', {
      carDetail: carDetail,
    });
  };

  const gotoContactForm = () => {
    sendEvent('goto_contact_form');

    const contactFormMarker = document.getElementById('car-detail-contact-form-marker');
    if (contactFormMarker) {
      contactFormMarker.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const onTradeInClick = () => {
    sendEvent('open_trade_in_form');

    eventBus.emit('open-trade-in-form', {
      carDetail: carDetail,
    });
  };

  const priceWatcherButtonLabel = computed(() => {
    return t('components.carDetail.actionButtons.openPriceWatcherModal');
    // if (width.value < 900) return t('components.carDetail.actionButtons.openPriceWatcherModal');
    // return t('components.carDetail.actionButtons.openPriceWatcherModalLong');
  });

  const priceAlertEnabled = useExternalWatcher<boolean>(() => (window as unknown as { auws?: AuwsObject }).auws?.settings?.flowAvailability?.price_alert ?? false);
  const showPriceWatchButton = ref(false);
  // "Inzahlungnahme" shares its row with the financing button (1:1), else with price watch.
  // With financing shown, price watch moves to a full row of its own.
  const tradeInShareRow = computed(() => financingCalculatorEnabled || showPriceWatchButton.value);

  watch(priceAlertEnabled, enabled => {
    showPriceWatchButton.value = !!enabled;
  });

  const onPriceWatcherClick = () => {
    sendEvent('open_price_watcher_modal');

    eventBus.emit('open-price-watcher-modal', {
      carDetail: carDetail,
    });
  };
</script>

<style lang="scss" scoped></style>
